import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import Logo from "#page-package/logo.tsx";

type Props = {
    url: string;
};

export default ({url}: Props): React.ReactElement => (
    <span className={css(styles.attribution)}>
        <a
            className={css(styles.link)}
            href={url}
            target="_blank"
            title={t`More free content available at ${url}!`}
            aria-label={t`More free content available at ${url}!`}
        >
            <Logo />
        </a>
    </span>
);

const styles = StyleSheet.create({
    attribution: {
        position: "fixed",
        bottom: 5,
        zIndex: 10,
        left: 5,
    },

    link: {
        color: color.white,

        ":hover": {
            color: color.blue,
        },
    },
});
